import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["modal"]

  open(event) {
    const {modalId} = event.currentTarget.dataset;
    const modal = this.modalTargets.find(m => m.dataset.modalId === modalId);
    if (modal) modal.showModal();
  }

  close(event) {
    const {modalId} = event.currentTarget.dataset;
    const modal = this.modalTargets.find(m => m.dataset.modalId === modalId);
    modal.close();
  }

  clickOutside(event) {
    const {modalId} = event.currentTarget.dataset;
    const modal = this.modalTargets.find(m => m.dataset.modalId === modalId);

    if (event.target === modal) modal.close();
  }
}
